import React, { FC } from 'react'

import { PRIMARY_DARKER } from '../../../utils/constants'

const AddIcon: FC<{ size?: string, fill?: string }> = ({ size = '14', fill = PRIMARY_DARKER }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6.125"
      y="0.875"
      width="1.75"
      height="12.25"
      rx="0.875"
      fill={fill}
    />
    <rect
      x="0.875"
      y="6.125"
      width="12.25"
      height="1.75"
      rx="0.875"
      fill={fill}
    />
  </svg>

)

export default AddIcon
